import { Funcionario } from '../domain/funcionario.model';
import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';

export class FuncionarioSerializer extends DomainSerializer<Funcionario> {}
